/**
 * "Shop by brand" — Load more.
 *
 * Shopify's `{% paginate %}` gives real pagination (`?page=2`, etc.) but no built-in AJAX
 * "Load more" button. This fetches the next page's full HTML, pulls out the matching grid
 * container by id, and appends its brand tiles to the current grid — same technique used
 * for infinite-scroll-style grids when there's no lightweight JSON/section-rendering
 * endpoint to call instead.
 */
(() => {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-collections-by-brand-load-more]');
    if (!button || button.classList.contains('loading')) return;

    const grid = document.getElementById(button.dataset.gridId);
    const nextUrl = button.dataset.nextUrl;
    if (!grid || !nextUrl) return;

    button.classList.add('loading');
    button.disabled = true;

    fetch(nextUrl)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = doc.getElementById(grid.id);
        if (nextGrid) {
          grid.insertAdjacentHTML('beforeend', nextGrid.innerHTML);
        }

        const nextButton = doc.querySelector(
          `[data-collections-by-brand-load-more][data-grid-id="${grid.id}"]`
        );
        if (nextButton && nextButton.dataset.nextUrl) {
          button.dataset.nextUrl = nextButton.dataset.nextUrl;
        } else {
          button.remove();
        }
      })
      .catch((error) => {
        console.error('Shop by brand: could not load more brands', error);
      })
      .finally(() => {
        button.classList.remove('loading');
        button.disabled = false;
      });
  });
})();
